import { Popover, PopoverHeader, PopoverBody } from "reactstrap";

import DatetimeRenderer from "../../Material/DatetimeRenderer";
import "./FieldHistoryPopover.css";

const FieldHistoryPopover = ({ title, history = [], isOpen, target, toggle }) => {

    // Detect "old -> new" pattern and format visually
    const renderDiffText = (text) => {
        if (!text) return text;

        const arrowIndex = text.indexOf("->");
        if (arrowIndex === -1) return text;

        let oldText = text.substring(0, arrowIndex).trim();
        let newText = text.substring(arrowIndex + 2).trim();

        const prefixesToRemove = [
            "Incident Updated: notes:",
            "Incident Updated:",
            "notes:"
        ];

        prefixesToRemove.forEach(prefix => {
            oldText = oldText.replace(prefix, "").trim();
        });

        return (
            <div className="fh-diff-wrapper">
                <span className="fh-new-text">{newText}</span>
                <span className="fh-arrow">←</span>
                <span className="fh-old-text">{oldText}</span>
            </div>
        );
    };



    return (
        <Popover placement="left" isOpen={isOpen} target={target} toggle={toggle} className="fh-popover" trigger="legacy">
            <PopoverHeader className="fh-header">{title} History</PopoverHeader>
            <PopoverBody className="fh-body">
                {history.length > 0 ? (
                    history.map((item, idx) => (
                        <div key={idx} className="fh-card">
                            <div className="fh-user">
                                <div className="fh-avatar">
                                    {item.user?.length > 0 ? item.user[0].toUpperCase() : "?"}
                                </div>
                                <div className="fh-username">{item.user || "--"}</div>
                            </div>
                            <div className="fh-detail">
                                {renderDiffText(item.comment)}
                            </div>
                            <div className="fh-date">
                                {item.date ? <DatetimeRenderer datetime={item.date} /> : "--"}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="fh-empty">No History Found</div>
                )}
            </PopoverBody>
        </Popover>
    );
};

export default FieldHistoryPopover;
